import { createIcon } from '~/utils';

export const MenuIcon = createIcon({
  viewBox: '0 0 24 38',
  path: [
    <rect y='15' width='24' height='2' rx='1' />,
    <rect x='8' y='21' width='16' height='2' rx='1' />,
  ],
});
